const AI_IMPORT_PPT_PDF = 'AI Import'
const IMPORT_PPT_PDF = 'Import'
const UPLOAD_AUDIO = 'Upload audio'
const UPLOAD_IMAGE = 'Upload image'
const IMPORT_SPREADSHEET = 'Import spreadsheet'
const AUDIENCE_AUTHENTICATION = 'Audience authentication'
const AI_CHATBOT_IMPORT = 'AI Chatbot Import'
const UPLOAD_V2 = 'Import V2'

export default {
  AI_IMPORT_PPT_PDF,
  IMPORT_PPT_PDF,
  UPLOAD_AUDIO,
  UPLOAD_IMAGE,
  IMPORT_SPREADSHEET,
  AUDIENCE_AUTHENTICATION,
  AI_CHATBOT_IMPORT,
  UPLOAD_V2,
}
